import React from 'react';
import ImageWithLoading from '../ImageWithLoading/ImageWithLoading';
import styles from './AvatarProfile.module.css';

interface AvatarProfileProps {
  src?: string | null;
  size?: number;
  className?: string;
}

const AvatarProfile: React.FC<AvatarProfileProps> = ({ src, size = 101, className }) => (
  <div
    className={`${styles.circle} ${className ?? ''}`}
    style={{ width: size, height: size }}
  >
    <div className={styles.middle}>
      <div className={styles.inner}>
        {src ? (
          <img src={src} alt="Avatar" />
        ) : (
          <span
            className={`${styles.faceIcon} material-symbols-outlined`}
            style={{ fontSize: size * 0.79 }}
          >
            face
          </span>
        )}
      </div>
    </div>
  </div>
);

export default AvatarProfile;
